import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Switch, Route, useLocation } from 'react-router-dom'
import { setLanguage } from './actions/language'
import DependentRegScreen from './containers/dependentRegScreen'
import ErrorScreen from './containers/errorScreen'
import ImmunizationScreen from './containers/immunizationScreen'
import LoginScreen from './containers/loginScreen'
import MainScreen from './containers/mainScreen'
import NewHomePage from './containers/newHomePage'
import VaccinePassportScreen from './containers/vaccinePassScreen'
import EmbeddedErrorScreen from './containers/embeddedErrorScreen'
import { LANG_EN } from './util/language'
import { isInIFrame } from './util/util'
import { ONLY_ALLOW_EMBED, GNB_WEBSITE_EN, GNB_WEBSITE_FR } from './globals/settings'


const Router = (props) => {
    
    const dispatch = useDispatch()
    const location = useLocation()
    const language = useSelector((state) => state.language.language)
    const queryLanguage = new URLSearchParams(location.search).get('lang')

    useEffect(() => {
        if(queryLanguage && (language !== queryLanguage)){
            dispatch(setLanguage(queryLanguage));
        }
    }, [queryLanguage]);


    useEffect(() => {
        // TODO: this will redirect to the wrong language if the query parameter is in the link
        //       but realistically we don't care about this and its a pain to fix.
        if(ONLY_ALLOW_EMBED && !isInIFrame()){
            const redirectUrl = language === LANG_EN ? GNB_WEBSITE_EN : GNB_WEBSITE_FR
            window.location.replace(redirectUrl);
        }
    }, [language]);

    return ( 
        <Switch>
            <Route exact path="/" component={LoginScreen} />
            <Route path="/results" component={MainScreen} /> 
            <Route path ="/app" component={NewHomePage} />
            <Route path="/register_dependent" component={DependentRegScreen} />
            <Route path="/error" component={ErrorScreen} />
            <Route path="/immunizations" component={ImmunizationScreen} />
            <Route path="/vaccination_pass" component={VaccinePassportScreen} />
            <Route path="/embedding_error"  component={EmbeddedErrorScreen}/>
        </Switch>
    )
};


export default Router
